module.exports = __webpack_public_path__ + "assets/question_icon.80b3e1b2.svg";